import { Box, Stack } from "@mui/material";
import { CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";

interface BadgeProps {
  label: string;
  backgroundColor: string;
  textColor: string;
  showIcon?: boolean;
}

export interface JobCardData {
  badges: BadgeProps[];
  jobType: string;
  workplace: string;
  location: string;
  role: string;
  pay: string;
}

function Badge({ label, backgroundColor, textColor, showIcon = false }: BadgeProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing="3px"
      sx={{
        backgroundColor,
        borderRadius: "77px",
        padding: "4.6px 9.2px",
        paddingLeft: showIcon ? "4.6px" : "9.2px",
        height: 18,
      }}
    >
      {showIcon && <CbhIcon type="bolt-filled" sx={{ width: 12, height: 12, color: textColor }} />}
      <Text
        sx={{
          fontSize: "9.2px",
          fontWeight: 500,
          lineHeight: "11.122px",
          color: textColor,
        }}
      >
        {label}
      </Text>
    </Stack>
  );
}

export function JobCard({ data }: { data: JobCardData }) {
  return (
    <Box
      sx={{
        width: 293,
        height: 136,
        backgroundColor: "common.white",
        border: "0.767px solid rgba(0, 0, 0, 0.07)",
        borderRadius: "18px",
        padding: "12px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing="3px">
          {data.badges.map((badge) => (
            <Badge key={badge.label} {...badge} />
          ))}
        </Stack>
        <CbhIcon type="like-outlined" sx={{ width: 18, height: 18, color: "text.primary" }} />
      </Stack>

      <Stack spacing="2px">
        <Stack direction="row" alignItems="center" spacing="3px">
          <Text
            sx={{
              fontSize: "10.738px",
              fontWeight: 500,
              lineHeight: "13.039px",
              letterSpacing: "-0.1074px",
              color: "text.primary",
            }}
          >
            {data.jobType}
          </Text>
          <CbhIcon type="sun-filled" sx={{ width: 11, height: 11, color: "text.primary" }} />
        </Stack>
        <Text
          sx={{
            fontSize: "10.738px",
            fontWeight: 400,
            lineHeight: "13.039px",
            letterSpacing: "-0.1074px",
            color: "text.secondary",
          }}
        >
          {data.workplace}
        </Text>
        <Text
          sx={{
            fontSize: "10.738px",
            fontWeight: 400,
            lineHeight: "13.039px",
            letterSpacing: "-0.1074px",
            color: "text.tertiary",
          }}
        >
          {data.location}
        </Text>
      </Stack>

      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Text
          sx={{
            fontSize: "10.738px",
            fontWeight: 500,
            lineHeight: "13.039px",
            letterSpacing: "-0.1074px",
            color: "text.secondary",
          }}
        >
          {data.role}
        </Text>
        <Stack direction="row" alignItems="center" spacing="3px">
          <Text
            sx={{
              fontSize: "12.27px",
              fontWeight: 500,
              lineHeight: "11.122px",
              color: "text.primary",
            }}
          >
            {data.pay}
          </Text>
        </Stack>
      </Stack>
    </Box>
  );
}

export const JOB_CARDS: JobCardData[] = [
  {
    badges: [
      {
        label: "Instant interview",
        backgroundColor: "intent.success.background",
        textColor: "intent.success.text",
        showIcon: true,
      },
      {
        label: "CNA",
        backgroundColor: "intent.warning.background",
        textColor: "intent.warning.text",
      },
    ],
    jobType: "Full Time",
    workplace: "American Orchards Senior Community",
    location: "2 mi",
    role: "CNA",
    pay: "$22.50 - $24.00 /hr",
  },
  {
    badges: [
      {
        label: "Instant interview",
        backgroundColor: "intent.success.background",
        textColor: "intent.success.text",
        showIcon: true,
      },
      {
        label: "Prek",
        backgroundColor: "intent.warning.background",
        textColor: "intent.warning.text",
      },
    ],
    jobType: "Full Time",
    workplace: "Growing Minds Learning Center",
    location: "4 mi",
    role: "Lead Teacher",
    pay: "$24.00 - $26.00 /hr",
  },
  {
    badges: [
      {
        label: "Instant interview",
        backgroundColor: "intent.success.background",
        textColor: "intent.success.text",
        showIcon: true,
      },
      {
        label: "Inf, Tod",
        backgroundColor: "intent.warning.background",
        textColor: "intent.warning.text",
      },
    ],
    jobType: "Full Time",
    workplace: "Bright Smiles Dentistry",
    location: "3 mi",
    role: "Dental Assistant",
    pay: "$22.00 - $24.00 /hr",
  },
];
